import React from "react";
import { SignIn } from "../../../../components";
function UserSignIn() {
  return <SignIn isAdminLogin={false} />;
}

export default UserSignIn;
